export class Otp {
    otpNo: number
    tel: string
    email: string
    code: string
    type: string
    authenticationDate: string
} 

export class OtpSendRequest {
    userId: string
	tel: string
	email: string
	type: string
}
export class OtpCheckDTO {
    type: string
	code: string
	tel: string
	email: string
	userId: string
    userName: string
	timeCheck: boolean = true
	// 기본 체크 시간 (분)
	intervalCheckTime: number = 5

}